import { render, staticRenderFns } from "./ResumeCard.vue?vue&type=template&id=8ac18a64&"
import script from "./ResumeCard.vue?vue&type=script&lang=js&"
export * from "./ResumeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports